import React from "react";
import { MapPin, ExternalLink } from "lucide-react";

// Keyless Google Maps embed (works in iframes without an API key).
export const RouteMap = ({ from, to, stops = [], testId = "route-map" }) => {
  if (!from && !to) return null;
  const clean = (s) => (s || "").trim();
  const way = [clean(from), ...stops.map(clean).filter(Boolean), clean(to)].filter(Boolean);
  const embedSrc = to
    ? `https://maps.google.com/maps?saddr=${encodeURIComponent(way[0])}&daddr=${way.slice(1).map((w) => encodeURIComponent(w)).join("+to:")}&output=embed`
    : `https://maps.google.com/maps?q=${encodeURIComponent(from)}&output=embed`;
  const openUrl = to
    ? `https://www.google.com/maps/dir/${way.map((w) => encodeURIComponent(w)).join("/")}`
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(from)}`;
  return (
    <div data-testid={testId} className="rounded-xl overflow-hidden border border-slate-200">
      <iframe
        title="route-map"
        data-testid={`${testId}-iframe`}
        src={embedSrc}
        className="w-full h-44 border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <a
        data-testid={`${testId}-open`}
        href={openUrl}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center gap-1.5 bg-slate-50 py-2 text-xs font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-colors"
      >
        <MapPin className="w-3.5 h-3.5 text-amber-500" /> Open route in Google Maps <ExternalLink className="w-3 h-3" />
      </a>
    </div>
  );
};

export default RouteMap;
